import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalLeftUpOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M17 5.8V4H4v13h1.8V7.073L18.727 20 20 18.727 7.073 5.8z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalLeftUpOutlinedSize24Glyph.displayName = 'ArrowDiagonalLeftUpOutlinedSize24Glyph';
